import React, { FC } from 'react'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Typography, Link, makeStyles } from 'transfix-ui/core'
import { IShipperRateTypes, Maybe } from 'types/graphqlTypes'
import EquipmentIcon from 'apps/marketplace/pages/shipment-details/components/EquipmentIcon'
import ShipmentIcons, {
  getIcons,
} from 'apps/marketplace/pages/shipment-details/components/ShipmentIcons'
import { ITrailerShipmentFragment } from 'apps/marketplace/pages/shippers/components/ShipperTrailers/graphql/TrailerShipmentFragment'
import { companyNameInitials } from 'utils/initials'
import EmptyInfo from './EmptyInfo'

interface IShipmentDisplayProps {
  shipment: Maybe<ITrailerShipmentFragment>
}

const useShipmentDisplayStyles = makeStyles({
  shipperName: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
})

const ShipmentDisplay: FC<IShipmentDisplayProps> = ({ shipment }) => {
  const styles = useShipmentDisplayStyles()
  const { characteristics, equipment, shipperApplication, shipperRateType } = shipment || {}
  const { name: shipperName } = shipperApplication || {}

  const icons = getIcons({
    ...characteristics,
    pricedUnderContract: shipperRateType === IShipperRateTypes.contract_primary,
    contractBackup: shipperRateType === IShipperRateTypes.contract_backup,
    sameDaySpot: shipperRateType === IShipperRateTypes.spot,
  })

  if (shipment) {
    return (
      <>
        <EquipmentIcon
          tooltip={equipment?.name}
          icon={equipment?.parentKey}
          className={styles.shipperName}
        />
        <Tooltip
          trigger={
            <Typography component='span' variant='body1' className={styles.shipperName}>
              {companyNameInitials(shipperName)}
            </Typography>
          }>
          {shipperName}
        </Tooltip>
        <Link
          href={`${__ROOT__}/shipment-details/${shipment.id}`}
          target='_blank'
          rel='noopener noreferrer'>
          <Typography variant='body1'>#{shipment.id}</Typography>
        </Link>
        <ShipmentIcons
          icons={icons}
          bouncedCount={characteristics?.bounceCount}
          rolledCount={characteristics?.rolloverCount}
        />
      </>
    )
  }

  return <EmptyInfo />
}

export default ShipmentDisplay
